import i18n from 'modules/core/lib/i18n'

/**
 * Given an attribute returns the header localized for the import table
 * This method aims to avoid I18n interpolation
 * @see https://www.notion.so/factorialco/Code-Pain-568f3ee12e7446fd875c6c3294d2fd7b?p=cccebffa0f934305af9e0edc663788de
 */
const getAttributeHeader = (attribute: string) => {
  switch (attribute) {
    case 'a3nom_employee_code':
      return i18n.t('import.table.headers.a3nom_employee_code')
    case 'a3innuva_employee_code':
      return i18n.t('import.table.headers.a3innuva_employee_code')
    case 'address_line_1':
      return i18n.t('import.table.headers.address_line_1')
    case 'address_line_2':
      return i18n.t('import.table.headers.address_line_2')
    case 'bank_number':
      return i18n.t('import.table.headers.bank_number')
    case 'bank_number_format':
      return i18n.t('import.table.headers.bank_number_format')
    case 'base_compensation_amount_in_cents':
      return i18n.t('import.table.headers.base_compensation_amount_in_cents')
    case 'base_compensation_type':
      return i18n.t('import.table.headers.base_compensation_type')
    case 'birthday_on':
      return i18n.t('import.table.headers.birthday_on')
    case 'city':
      return i18n.t('import.table.headers.city')
    case 'company_identifier':
      return i18n.t('import.table.headers.company_identifier')
    case 'contact_name':
      return i18n.t('import.table.headers.contact_name')
    case 'contact_number':
      return i18n.t('import.table.headers.contact_number')
    case 'country':
      return i18n.t('import.table.headers.country')
    case 'email':
      return i18n.t('import.table.headers.email')
    case 'personal_email':
      return i18n.t('import.table.headers.personal_email')
    case 'end_date':
      return i18n.t('import.table.headers.end_date')
    case 'first_name':
      return i18n.t('import.table.headers.first_name')
    case 'gender':
      return i18n.t('import.table.headers.gender')
    case 'identifier':
      return i18n.t('import.table.headers.identifier')
    case 'identifier_type':
      return i18n.t('import.table.headers.identifier_type')
    case 'job_title':
      return i18n.t('import.table.headers.job_title')
    case 'job':
      return i18n.t('import.table.headers.job')
    case 'last_name':
      return i18n.t('import.table.headers.last_name')
    case 'location':
      return i18n.t('import.table.headers.location')
    case 'manager_email':
      return i18n.t('import.table.headers.manager_email')
    case 'matricule':
      return i18n.t('import.table.headers.matricule')
    case 'nationality':
      return i18n.t('import.table.headers.nationality')
    case 'payment_frequency':
      return i18n.t('import.table.headers.payment_frequency')
    case 'phone_number':
      return i18n.t('import.table.headers.phone_number')
    case 'postal_code':
      return i18n.t('import.table.headers.postal_code')
    case 'preferred_name':
      return i18n.t('import.table.headers.preferred_name')
    case 'real_start_date':
      return i18n.t('import.table.headers.real_start_date')
    case 'remaining_vacations':
      return i18n.t('import.table.headers.remaining_vacations')
    case 'social_security_number':
      return i18n.t('import.table.headers.social_security_number')
    case 'state':
      return i18n.t('import.table.headers.state')
    case 'swift_bic':
      return i18n.t('import.table.headers.swift_bic')
    case 'tax_id':
      return i18n.t('import.table.headers.tax_id')
    case 'timeoff_manager_email':
      return i18n.t('import.table.headers.timeoff_manager_email')
    case 'timeoff_policy':
      return i18n.t('import.table.headers.timeoff_policy')
    case 'type':
      return i18n.t('import.table.headers.type')
    case 'working_hours_in_cents':
      return i18n.t('import.table.headers.working_hours_in_cents')
    case 'working_period_unit':
      return i18n.t('import.table.headers.working_period_unit')
    case 'zucchetti_employee_code':
      return i18n.t('import.table.headers.zucchetti_employee_code')
    case 'datev_api_employee_code':
      return i18n.t('import.table.headers.datev_api_employee_code')
    case 'datev_lug_api_employee_code':
      return i18n.t('import.table.headers.datev_lug_api_employee_code')
    case 'datev_employee_code':
      return i18n.t('import.table.headers.datev_employee_code')
    case 'retirement_regime_applied':
      return i18n.t('import.table.headers.retirement_regime_applied')
    case 'datev_lauds_employee_code':
      return i18n.t('import.table.headers.datev_lauds_employee_code')
    default:
      throw new Error(`Missing translation for import.table.headers.${attribute}`)
  }
}

export default getAttributeHeader
